import { render, staticRenderFns } from "./RetrieveUser.vue?vue&type=template&id=5f85287e&scoped=true"
import script from "./RetrieveUser.vue?vue&type=script&lang=js"
export * from "./RetrieveUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85287e",
  null
  
)

export default component.exports